import { type CountryCode, type Language } from 'ecosystem'
import { countryNames } from '../constants/countryNames'
import { normalizeCountryCode } from './payment'

const dictLocales: Record<Language, string> = {
  en: 'en-GB',
  sv: 'sv-SE',
  da: 'da-DK',
  no: 'nb-NO',
  de: 'de-DE',
  fi: 'fi-FI'
}
export const getFullLocale = (
  locale: Language,
  dictLocalesOverride?: Partial<Record<Language, string>>
) => {
  const dict = {
    ...dictLocales,
    ...dictLocalesOverride
  }
  const foundLocale = dict[locale]

  return foundLocale ?? locale
}

/**
 * Read the document language from the DOM, defaulting to `sv` when unset
 * or when called server-side. Restricted to the `Language` union so the
 * returned value can be passed straight into locale-keyed dictionaries.
 */
export const getDocumentLanguage = (): Language => {
  if (typeof document === 'undefined') return 'sv'
  const lang = document.documentElement.lang
  return (lang && lang in countryNames ? lang : 'sv') as Language
}

/**
 * Resolve a raw ISO country code (e.g. `"SE"`) to its localised country
 * name (e.g. `"Sverige"` in `sv`). Falls back to the original input when
 * the code isn't known or the locale dictionary is missing.
 */
export const resolveCountryName = (
  rawCountry: string | undefined | null,
  locale: Language
): string | null => {
  if (!rawCountry) return null
  const code = normalizeCountryCode(rawCountry) as CountryCode
  return countryNames[locale]?.[code] ?? rawCountry
}
